export function setCommunityNewsData(state, data) {
  return {
    ...state,
    communityNews: {
      ...state.communityNews,
      data: data
    }
  };
}

export function setCommunityNewsStatus(state, status) {
  return {
    ...state,
    communityNews: {
      ...state.communityNews,
      status: status
    }
  };
}
